import _get from "lodash.get";
import { formatHelper } from "helper/format";
import { PRODUCT_UI_BY_CODE } from "components/allInOneDashboard/constants/productUiMap";

const dashboardParsers = {};

dashboardParsers.portfolioAllocation = (res) => {
  if (res && res.data) {
    res = res.data;
  }
  if (!res) {
    return [];
  }

  let data = res.map((p) => ({
    stockName: _get(p, "stockName", null),
    shareCode: _get(p, "stockSymbol", null),
    quantity: _get(p, "quantity", 0) || 0,
    pendingActionableQty: 0,
    buyPrice: formatHelper.parseDecimal(_get(p, "buyPrice", 0)) || 0,
    totalBuyPrice: formatHelper.parseDecimal(_get(p, "totalBuyPrice", 0)) || 0,
    currentPrice: formatHelper.parseDecimal(_get(p, "currentPrice", 0)) || 0,
    totalCurrentPrice: formatHelper.parseDecimal(_get(p, "totalCurrentPrice", 0)) || 0,
    allocationPercentage: formatHelper.parseDecimal(_get(p, "allocationPercentage", 0)) || 0,
    profitPrice: formatHelper.parseDecimal(_get(p, "profitPrice", 0)) || 0,
    profitPercentage: formatHelper.parseDecimal(_get(p, "profitPercentage", 0)) || 0,
    profitType: _get(p, "profitType", null),
    capCategory: _get(p, "capCategory", null),
  }));

  return data;
};

dashboardParsers.portfolioOverview = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return {};
  }
  let data = {
    holdingValue: _get(res, "holdingValue", 0),
    totalInvestment: _get(res, "totalInvestment", 0),
    currentValue: formatHelper.parseDecimal(_get(res, "currentValue", null)) || 0,
    profit: formatHelper.parseDecimal(_get(res, "profit", null)) || 0,
    profitPercentage: formatHelper.parseDecimal(
      _get(res, "profitPercentage", null)
    ) || 0,
    cash: formatHelper.parseDecimal(_get(res, "cash", null)),
  };
  return data;
};

dashboardParsers.portfolioPerformance = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return {};
  }

  const roundDecimal = (val) => Number(Number(val).toFixed(2));
  const hasDataAny = (d) => (
    !Object.values(d).every((v) => ((!v || v === "-") ? true : false))
  );

  let data = {
    mtdPortfolio: roundDecimal(_get(res, "mtdPortfolio", "")),
    qtdPortfolio: roundDecimal(_get(res, "qtdPortfolio", "")),
    ytdPortfolio: roundDecimal(_get(res, "ytdPortfolio", "")),
    mtdNifty: roundDecimal(_get(res, "mtdNifty", "")),
    qtdNifty: roundDecimal(_get(res, "qtdNifty", "")),
    ytdNifty: roundDecimal(_get(res, "ytdNifty", "")),
    hasPortfolio: hasDataAny(res),
  };
  return data
};

dashboardParsers.portfolioChart = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return {};
  }

  const portfolioArr = (portfolio) =>
    portfolio.map((e) => [Date.parse(e.date), e.value]);
  const niftyArr = (nifty) => nifty.map((e) => [Date.parse(e.date), e.value]);

  return {
    portfolio: portfolioArr(_get(res, "portfolio", [])),
    nifty: niftyArr(_get(res, "nifty", [])),
  };
};
dashboardParsers.portfolioHeatmap = (res) => {
  return {
    portfolio: res?.jarvisPortfolio || [],
    nifty: res?.nifty || [],
  };
};


dashboardParsers.portfolioSector = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return [];
  }

  return res.map((e) => ({
    sector: _get(e, "sector", ""),
    amount: _get(e, "amount", 0),
  }));
};

dashboardParsers.portfolioMarket = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return [];
  }
  return res.map((e) => ({
    name: _get(e, "displayName", ""),
    amount: _get(e, "amount", 0),
  }));
};

dashboardParsers.welcomeVideoList = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return [];
  }

  return res.map((e) => ({
    description: _get(e, "description", ""),
    sequence: _get(e, "sequence", ""),
    link: _get(e, "link", ""),
    thumbnail: _get(e, "thumbnail", ""),
    title: _get(e, "title", ""),
  }));
};

dashboardParsers.customerStoryList = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return [];
  }

  return res.map((e) => ({
    description: _get(e, "description", ""),
    name: _get(e, "name", ""),
    ratings: _get(e, "ratings", ""),
    thumbnail: _get(e, "thumbnail", ""),
  }));
};

// RMS/Rebalance
dashboardParsers.portfolioAlert = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return {};
  }

  return {
    pendingTransaction: _get(res, "pendingTransaction", ""),
    title: _get(res, "title", ""),
    description: _get(res, "description", ""),
    tracsactionType: _get(res, "tracsactionType", ""),
    transactionStatus: _get(res, "transactionStatus", ""),
    hasExpired: _get(res, "hasExpired", ""),
    archiveMsg: _get(res, "archiveMsg", ""),
    newCallMsg: _get(res, "newCallMsg", ""),
    actionScreenTitle: _get(res, "actionScreenTitle", ""),
    actionScreenDescription: _get(res, "actionScreenDescription", ""),
    note: _get(res, "note", ""),
  };
};

dashboardParsers.portfolioPendingTransaction = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return {};
  }

  const sortStocks = (d, sort) =>
    d.filter((d) => d.actionTakenByUser === sort).map((s) => ({
      symbol: _get(s, "symbol", ""),
      quantity: _get(s, "qty", ""),
      suggested_quantity: _get(s, "suggested_quantity", ""),
      tracsactionType: _get(s, "tracsactionType", ""),
      action: _get(s, "action", ""),
      rate: _get(s, "rate", ""),
      actionTakenByUser: _get(s, "actionTakenByUser", ""),
    }));

  return {
    transactionDate: _get(res, "transactionDate", ""),
    completedStocks: sortStocks(_get(res, "stockDtls", []), 1),
    pendingStocks: sortStocks(_get(res, "stockDtls", []), 0),
  };
};

dashboardParsers.finalPortfolioConfirmation = (res) => {
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return [];
  }

  const d = res.map((p) => ({
    quantity: _get(p, "qty", ""),
    symbol: _get(p, "symbol", ""),
    name: _get(p, "stockName", ""),
  }));

  return d;

};

const SECTION_TAB_BY_CODE = {
  PRIME: "portfolio_management",
  PMS: "portfolio_management",
  US_STRATEGY: "portfolio_management",
  ATLAS: "portfolio_management",
  SENTIMENT: "derivatives",
};

const DEFAULT_DISPLAY_ORDER = {
  PORTFOLIO: 1,
  ONESTOCK: 2,
  RMS: 3,
  PHC: 4,
  PRIME: 1,
  US_STRATEGY: 2,
  ATLAS: 3,
  PMS: 4,
  SENTIMENT: 1,
};

const formatCurrency = (amount) => {
  if (amount == null || Number.isNaN(Number(amount))) {
    return "—";
  }
  return `₹${Number(amount).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  })}`;
};

const formatStockDate = (dateValue) => {
  if (!dateValue) return "—";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return String(dateValue);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const getReturnsTone = (label) => {
  if (label == null || label === "" || label === "—") {
    return "neutral";
  }
  const numeric = parseFloat(String(label).replace(/[^\d.-]/g, ""));
  if (Number.isNaN(numeric)) {
    return "neutral";
  }
  if (numeric > 0) return "gain";
  if (numeric < 0) return "loss";
  return "neutral";
};

const makeStat = (label, value, tone = "neutral", pillLabel = null) => ({
  label,
  value: value ?? "—",
  tone,
  pillLabel,
});

const buildPhcStatsFromPortfolio = (portfolio) => {
  if (!portfolio) {
    return [];
  }
  const returnsValue =
    portfolio.returns ?? portfolio.return ?? null;
  const returnsLabel =
    returnsValue == null
      ? "—"
      : String(returnsValue).includes("%")
        ? String(returnsValue)
        : `${returnsValue}%`;

  return [
    makeStat("No of Stocks", String(portfolio.no_of_stocks ?? "—")),
    makeStat("Portfolio Beta", String(portfolio.portfolio_beta ?? "—")),
    makeStat("Returns", returnsLabel, getReturnsTone(returnsLabel)),
  ];
};

const buildStatsForProduct = (productCode, unlocked) => {
  if (!unlocked) {
    return [];
  }

  switch (productCode) {
    case "PORTFOLIO":
      return [
        makeStat(
          "Investment Amt",
          formatCurrency(unlocked.investment_amount),
        ),
        makeStat(
          "Gain/Loss",
          unlocked.returns_label || "—",
          getReturnsTone(unlocked.returns_label),
        ),
      ];
    case "PRIME": {
      const returnsAmount =
        unlocked.returns_amount ??
        unlocked.absolute_returns ??
        unlocked.returns_value ??
        null;
      const returnsLabel = unlocked.returns_label || null;
      return [
        makeStat(
          "Portfolio Value",
          formatCurrency(
            unlocked.portfolio_value ?? unlocked.investment_amount,
          ),
        ),
        makeStat(
          "Invested Value",
          formatCurrency(
            unlocked.invested_value ?? unlocked.invested_amount ?? 0,
          ),
        ),
        makeStat(
          "Returns",
          returnsAmount != null
            ? formatCurrency(returnsAmount)
            : returnsLabel || "—",
          getReturnsTone(returnsLabel),
          returnsAmount != null ? returnsLabel : null,
        ),
      ];
    }
    case "SENTIMENT": {
      const sentimentValue =
        unlocked.sentiment_percent ??
        unlocked.sentiment_score ??
        unlocked.sentiment ??
        null;
      const sentimentStrength =
        unlocked.sentiment_strength || unlocked.sentiment_label || null;
      const pcrValue =
        unlocked.pcr ?? unlocked.put_call_ratio ?? unlocked.pcr_value ?? null;
      const pcrStrength = unlocked.pcr_strength || unlocked.pcr_label || null;
      const sentimentDisplay = (() => {
        if (sentimentValue == null || sentimentValue === "") return "—";
        const raw = String(sentimentValue);
        const withPct = raw.includes("%") ? raw : `${raw}%`;
        return sentimentStrength
          ? `${withPct} (${sentimentStrength})`
          : withPct;
      })();
      const pcrDisplay = (() => {
        if (pcrValue == null || pcrValue === "") return "—";
        const raw = String(pcrValue);
        return pcrStrength ? `${raw} (${pcrStrength})` : raw;
      })();
      return [
        makeStat("Sentiment %", sentimentDisplay),
        makeStat("PCR", pcrDisplay),
      ];
    }
    case "ONESTOCK": {
      const stocks = unlocked.stock_data || [];
      if (!stocks.length) {
        return [];
      }
      const firstStock = stocks[0];
      return [
        makeStat(
          "Buy Price",
          firstStock.buy_price != null
            ? formatCurrency(firstStock.buy_price)
            : firstStock.buy_price_label || "—",
        ),
        makeStat(
          "Date",
          formatStockDate(firstStock.buy_date ?? firstStock.date),
        ),
      ];
    }
    case "RMS":
      return [
        makeStat(
          "AUM under Monitor",
          formatCurrency(unlocked.aum_under_monitor),
        ),
        makeStat(
          "Avg Downfall Saved",
          formatCurrency(unlocked.avg_downfall_saved),
        ),
        makeStat(
          "Opportunity Lost",
          formatCurrency(unlocked.opportunity_loss),
        ),
      ];
    case "PHC": {
      const portfolios = unlocked.portfolio_data || [];
      if (!portfolios.length) {
        return [];
      }
      return buildPhcStatsFromPortfolio(portfolios[0]);
    }
    default:
      return [];
  }
};

const parseProductSubtitle = (raw) => {
  if (raw == null || raw === "") {
    return { subtitle: "", description: "" };
  }

  if (typeof raw !== "string") {
    return { subtitle: String(raw), description: "" };
  }

  const trimmed = raw.trim();
  if (trimmed.startsWith("[")) {
    try {
      const parts = JSON.parse(trimmed);
      if (Array.isArray(parts) && parts.length) {
        return {
          subtitle: parts[0] || "",
          description: parts[1] || parts[0] || "",
        };
      }
    } catch (error) {
      // fall through — treat as plain subtitle
    }
  }

  return { subtitle: raw, description: "" };
};

const flattenPrivateWealth = (privateWealth) => {
  if (Array.isArray(privateWealth)) {
    return privateWealth;
  }

  if (!privateWealth || typeof privateWealth !== "object") {
    return [];
  }

  const portfolioManagement = (
    privateWealth.portfolio_management || []
  ).map((item) => ({
    ...item,
    section_tab: item.section_tab || "portfolio_management",
  }));

  const derivatives = (privateWealth.derivatives || []).map((item) => ({
    ...item,
    section_tab: item.section_tab || "derivatives",
  }));

  return [...portfolioManagement, ...derivatives];
};

const normalizeDashboardProduct = (apiItem, index) => {
  const code = apiItem.product_code;
  const ui = PRODUCT_UI_BY_CODE[code];

  if (!ui) {
    return null;
  }

  if (apiItem.is_enabled === false) {
    return null;
  }

  const unlocked = apiItem.unlocked_data;
  const stockData = unlocked?.stock_data || [];
  const portfolioData = unlocked?.portfolio_data || [];
  const firstStock = stockData[0];
  const { subtitle, description } = parseProductSubtitle(apiItem.subtitle);

  return {
    ...ui,
    name: apiItem.title || ui.name,
    title: apiItem.title || ui.name,
    subtitle: subtitle || ui.subtitle || "",
    description: description || ui.description || "",
    lockedSubtitle: subtitle || ui.subtitle || "",
    infoDescription:
      unlocked?.description ||
      description ||
      subtitle ||
      apiItem.title ||
      "",
    isLocked: Boolean(apiItem.is_locked),
    isEnabled: apiItem.is_enabled !== false,
    // Only static coming-soon products (US Strategy, PMS). Locked live products
    // (e.g. Prime with unlocked_data null) must use the locked marketing card.
    comingSoon: Boolean(ui.comingSoon),
    displayOrder:
      apiItem.display_order ?? DEFAULT_DISPLAY_ORDER[code] ?? index + 1,
    sectionTab:
      apiItem.section_tab || SECTION_TAB_BY_CODE[code] || null,
    unlockedData: unlocked,
    stats: buildStatsForProduct(code, unlocked),
    riskProfile: unlocked?.risk_profile || null,
    planName: unlocked?.plan_name || null,
    stockSubtitle: firstStock?.stock_name || null,
    revealStatus: unlocked?.reveal_status || null,
    revealNote: unlocked?.reveal_note || null,
    revealTime: unlocked?.reveal_time || null,
    stockData,
    portfolioData,
    monitorLabel:
      code === "RMS"
        ? "Portfolio Under Monitor"
        : code === "ONESTOCK"
          ? "Stock of the Day"
          : code === "PHC"
            ? "Portfolio Report"
            : code === "SENTIMENT"
              ? "NIFTY Sentiment Score"
              : null,
  };
};

const sortByDisplayOrder = (list) =>
  [...list].sort((a, b) => a.displayOrder - b.displayOrder);

const collectDisabledProductCodes = (items = []) =>
  items
    .filter((item) => item?.is_enabled === false && item?.product_code)
    .map((item) => item.product_code);

dashboardParsers.productDetails = (response) => {
  const payload = response?.data ?? response;
  const essentials = _get(payload, "investing_essentials", []) || [];
  const wealth = flattenPrivateWealth(_get(payload, "private_wealth", null));

  return {
    investingEssentials: sortByDisplayOrder(
      essentials.map(normalizeDashboardProduct).filter(Boolean),
    ),
    privateWealth: sortByDisplayOrder(
      wealth.map(normalizeDashboardProduct).filter(Boolean),
    ),
    disabledProductCodes: collectDisabledProductCodes([
      ...essentials,
      ...wealth,
    ]),
  };
};

export { dashboardParsers };
